import { render, staticRenderFns } from "./DocketEntryEditorAutomatedText.vue?vue&type=template&id=66b8f6b3&scoped=true&"
import script from "./DocketEntryEditorAutomatedText.vue?vue&type=script&lang=js&"
export * from "./DocketEntryEditorAutomatedText.vue?vue&type=script&lang=js&"
import style0 from "./DocketEntryEditorAutomatedText.vue?vue&type=style&index=0&id=66b8f6b3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b8f6b3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VAlert,VAutocomplete,VBanner,VCard,VCol,VContainer,VForm,VRow,VSwitch,VTextarea})
